/* Gründerzeit theme — progressive enhancement only. Alles funktioniert auch ohne JS. */
(function () {
  'use strict';

  /* Mobile-Navigation: Drawer schließen bei Klick außerhalb, Escape oder Linkwahl */
  const drawer = document.getElementById('NavDrawer');
  if (drawer) {
    document.addEventListener('click', (event) => {
      if (drawer.open && !drawer.contains(event.target)) drawer.removeAttribute('open');
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer.open) drawer.removeAttribute('open');
    });
    drawer.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => drawer.removeAttribute('open'));
    });
  }

  /* Warenkorb: Menge ändern schickt das Formular ab (Fallback: Button „Aktualisieren“) */
  document.querySelectorAll('[data-cart-qty]').forEach((input) => {
    input.addEventListener('change', () => {
      const form = input.closest('form');
      if (form) form.submit();
    });
  });
})();
